
class IcmCalc {
    constructor(defaults) {
        this.calcItems = [];
        this.defaultValue = defaults.defaultValue;
        this.initializeCalcItems(defaults.users);

        this.wrapperTriggers = defaults.wrapperTriggers;
        this.wrapperItems = document.getElementById(defaults.wrapperItems);
        this.range = new Range(defaults.users, this.defaultValue);
        this.dropdown = new Dropdown(defaults.users, this.defaultValue);

        this.appendTriggers();
        this.appendCalcItems();
        this.addEventListeners(defaults.users);
        this.updateTotalStackValue();
        this.updateTotalPayoutValue();
    }
    appendTriggers() {
        const wrapper = document.getElementById(this.wrapperTriggers);

        if (wrapper) {
            wrapper.appendChild(this.range.input);
            wrapper.appendChild(this.range.div);
            wrapper.appendChild(this.dropdown.dropdown);
        } else {
            console.error(`Element with ID #${this.wrapperTriggers} not found.`);
        }
    }
    initializeCalcItems(users) {
        const jsonData = document.getElementById('jsonData');
        if (jsonData) {
            const dataValue = jsonData.getAttribute('data-value');
            const parsedData = dataValue ? JSON.parse(dataValue) : [];
            const itemCount = parsedData.length > 0 ? parsedData.length : this.defaultValue;

            if (parsedData.length != 0 && parsedData.length != IcmDefaults.defaultValue) {
                this.defaultValue = parsedData.length;
            }
            
            for (let i = 0; i < itemCount; i++) {
                const itemData = parsedData[i] || {};
                const calcItem = new CalcItem(i, false, itemData);
                this.calcItems.push(calcItem);
                if (i===0) {
                    calcItem.element.classList.add('li-first');
                    calcItem.payout.placeholder = '100';
                    calcItem.stack.placeholder = '10000';
                }
                else if (i===1) {
                    calcItem.element.classList.add('li-second');
                    calcItem.payout.placeholder = '60';
                    calcItem.stack.placeholder = '8000';
                }
                else if (i===2) {
                    calcItem.element.classList.add('li-third');
                    calcItem.payout.placeholder = '30';
                    calcItem.stack.placeholder = '5000';
                }
            }
            // const hiddenItems = Number(users) - Number(this.calcItems.length);
            for (let i = this.calcItems.length; i < users; i++) {
                const calcItemHidden = new CalcItem(i, true);
                if (i===2) {
                    calcItemHidden.element.classList.add('li-third');
                }
                this.calcItems.push(calcItemHidden);
            }
            // console.log(hiddenItems);
        } else {
            console.error('Element with ID #jsonData not found.');
        }
    }

    appendCalcItems() {
        if (this.wrapperItems) {
            this.calcItems.forEach(item => {
                this.wrapperItems.appendChild(item.element);
            });
        } else {
        console.error(`Element with ID #${this.wrapperItems} not found.`);
        }
    }

    updateCalcItemsCount(totalItems) {
        if (this.calcItems.length < totalItems) {
            const newItemCount = totalItems - this.calcItems.length;
            for (let i = 0; i < newItemCount; i++) {
                const calcItem = new CalcItem(this.calcItems.length + i, {});
                this.calcItems.push(calcItem);
                if (this.wrapperItems) {
                    this.wrapperItems.appendChild(calcItem.element);
                }
            }
        }
        this.calcItems.forEach((item, index) => {
            if (index < totalItems) {
                item.element.classList.remove('d-none'), item.element.classList.add('d-flex');
                item.stack.classList.remove('d-none'), item.stack.classList.add('d-flex');
                item.payout.classList.remove('d-none'), item.payout.classList.add('d-flex');
                item.result.classList.remove('d-none'), item.result.classList.add('d-flex');
            } else {
                item.element.classList.remove('d-flex'), item.element.classList.add('d-none');
                item.stack.classList.remove('d-flex'), item.stack.classList.add('d-none');
                item.payout.classList.remove('d-flex'), item.payout.classList.add('d-none');
                item.result.classList.remove('d-flex'), item.result.classList.add('d-none');
            }
        });
    }

    updateTotalStackValue() {
        let totalStackValue = 0;
        this.calcItems.forEach(calcItem => {
            if (!calcItem.element.classList.contains("d-none")) {
            totalStackValue += parseFloat(calcItem.stack.value || 0);
            }
        });
        // console.log('Updated Total Stack Value:', totalStackValue);
        document.getElementById('stackAll').innerHTML = totalStackValue;
        return totalStackValue;
    }
    updateTotalPayoutValue() {
        let totalPayoutValue = 0;
        this.calcItems.forEach(calcItem => {
            if (!calcItem.element.classList.contains("d-none")) {
                totalPayoutValue += parseFloat(calcItem.payout.value || 0);
            }
        });
        // console.log('Updated Total Payout Value:', totalPayoutValue);
        document.getElementById('payoutAll').innerHTML = totalPayoutValue;
        return totalPayoutValue;
    }
    setPlaceholderToNone() {
        this.calcItems.forEach(calcItem => {
            calcItem.payout.placeholder = '';
            calcItem.stack.placeholder = '';
        });
    }
    setErrorMessage(item, text, type) {
        const errorMessage = document.createElement('div');
        errorMessage.className = 'd-flex py-2 px-3 shadow-4 error-message';
        errorMessage.innerHTML = text;

        if (type === 'payout') {
            this.calcItems[item].element.children[0].classList.add('_error');
            this.calcItems[item].payout.parentNode.appendChild(errorMessage)
        } 
        else if (type === 'stack') {
            this.calcItems[item].element.children[1].classList.add('_error');
            this.calcItems[item].stack.parentNode.appendChild(errorMessage)
        } 
        else {
            this.calcItems[item].element.appendChild(errorMessage)
        }
    }
    removeErrorMessage() {
        this.calcItems.forEach((item) => {
            item.element.children[0].classList.remove('_error');
            item.element.children[1].classList.remove('_error');
            //console.log(item.element.querySelectorAll('error-message'))
            item.element.querySelectorAll('.error-message').forEach((error) => {
                error.remove();
            })
        });
    }
    addEventListeners(users) {
        this.calcItems.forEach(calcItem => {
            calcItem.stack.addEventListener('click', () => {
                this.updateTotalStackValue();
                this.setPlaceholderToNone();
            }, { once: true });
            calcItem.payout.addEventListener('click', () => {
                this.updateTotalPayoutValue();
                this.setPlaceholderToNone();
            }, { once: true });
            calcItem.stack.addEventListener('input', () => {
                this.updateTotalStackValue();
                this.setPlaceholderToNone();
            });
            calcItem.payout.addEventListener('input', () => {
                this.updateTotalPayoutValue();
                this.setPlaceholderToNone();
            });
        });
        this.range.input.addEventListener('input', () => {
            // console.log('RANGE: ', this.range.input.value);
            if (this.range.input.value === '1') {
                this.range.input.value = 2;
            }
            this.updateCalcItemsCount(this.range.input.value);
            this.updateTotalPayoutValue();
            this.updateTotalStackValue();
            showResultBtnHideShareBtn();
            // const tempSliderValue = this.range.input.value;
            this.range.div.innerHTML = this.range.input.value;
            this.range.background(users);
            // Обновляем параметр defaultValue чтобы при reset оставалось текущее значение
            this.range.input.defaultValue = this.range.input.value;

        });

        this.dropdown.dropdownText.addEventListener('click', (event) => {
            this.dropdown.dropdown.classList.toggle('_active');
            event.stopPropagation();
        });

        this.dropdown.dropdownInner.addEventListener('click', (event) => {
            if (event.target.classList.contains('calculator__icm-dropdown-inner-item')) {
                const value = event.target.getAttribute('data-value');
                this.dropdown.dropdownText.querySelector('span').textContent = value;
                // console.log('DROPDOWN: ', value);
                this.updateCalcItemsCount(value);
                this.updateTotalPayoutValue();
                this.updateTotalStackValue();
                showResultBtnHideShareBtn();
                this.dropdown.dropdown.classList.remove('_active');
            }
            event.stopPropagation();
        });

        document.addEventListener('click', () => {
            if (this.dropdown.dropdown.classList.contains('_active')) {
                this.dropdown.dropdown.classList.remove('_active');
            }
        });

        const resetBtns = document.querySelectorAll('[data-elem="reset-btn"]');
        resetBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.calcItems.forEach(calcItem => {
                    calcItem.stack.value = '';
                    calcItem.payout.value = '';
                    calcItem.result.value = '';
                    
                })
                this.updateTotalStackValue();
                this.updateTotalPayoutValue();
                showResultBtnHideShareBtn();
            })
        });
    }
}

class Range {
    constructor(users, defaultValue) {
        this.input = Object.assign(document.createElement('input'), {
            type: 'range',
            min: '1',
            max: users,
            value: defaultValue,
            defaultValue: defaultValue
        });
        this.div = Object.assign(document.createElement('div'));
        this.div.classList.add('calculator__icm-range-value');
        this.div.innerHTML = defaultValue;
        this.background(users);
    }
    background(users) {
        const tempSliderValue = this.input.value; 
        const progress = (tempSliderValue / users) * 100 - 2.5;
        this.input.style.background = `linear-gradient(90deg, rgba(88,163,205,1) 0%, rgba(85,205,162,1) ${progress}%, rgba(152,152,152,1) ${progress}%)`;
        if (progress < 20) {
            this.div.style.left = (progress - 1.5) + '%';
        } else if ( progress < 70) {
            this.div.style.left = (progress - 1) + '%';
        } else {
            this.div.style.left = (progress) + '%';
        }
    }
}

class Dropdown {
    constructor(users, defaultValue) {
        this.maxUsers = users;

        this.dropdown = this.createElement('div', 'calculator__icm-dropdown');
        this.dropdownText = this.createElement('div', 'calculator__icm-dropdown-text',
         `Number of players: <span class="f-sbold c-text lh-26 fs-16">${defaultValue}</span>`);
        this.dropdown.appendChild(this.dropdownText);

        this.dropdownInner = this.createDropdownInner();
        this.dropdown.appendChild(this.dropdownInner);
    }

    createElement(tag, className, innerHTML = '') {
        const element = document.createElement(tag);
        element.className = className;
        element.innerHTML = innerHTML;
        return element;
    }

    createDropdownInner() {
        const ulElement = this.createElement('ul', 'calculator__icm-dropdown-inner');
        for (let i = 2; i <= this.maxUsers; i++) {
            const item = this.createElement('div', 'calculator__icm-dropdown-inner-item', i);
            item.setAttribute('data-value', i);
            ulElement.appendChild(item);
        }
        return ulElement;
    }
}

class CalcItem {
    constructor(index, hidden, data = {}) {
        this.element = this.createElement('li', 'calculator-item d-flex flex-row', hidden);
        this.stack = this.createInput('stack', index, data.stack || 0, false, hidden);
        this.payout = this.createInput('payout', index, data.payout || 0, false, hidden);
        this.result = this.createInput('result', index, data.result || 0, true), hidden;

        this.element.appendChild(this.createInputContainer(this.payout));
        this.element.appendChild(this.createInputContainer(this.stack));
        this.element.appendChild(this.createInputContainer(this.result));
    }

    createElement(tag, className, hidden, innerHTML = '') {
        const element = document.createElement(tag);
        element.className = className;
        element.innerHTML = innerHTML;
        if (hidden) {
            element.classList.remove('d-flex');
            element.classList.add('d-none');
        }
        return element;
    }

    createInput(name, index, value, disabled, hidden) {
        const input = this.createElement('input', 'calculator__input br-4 lh-20 fs-15 f-reg');
        input.type = 'number';
        input.name = name;
        input.id = `form-icm-${name}-${index}`;
        input.placeholder = 0;
        if (value != 0) {
            input.value = value;
        }
        if (disabled) {
            input.classList.add('pe-n', 'c-bg-lgray', 'c-text', 'f-bold');
            input.disabled = true;
            input.placeholder = '';
        }
        if (hidden) {
            input.classList.add('d-none');
        }
        return input;
    }

    createInputContainer(input) {
        const container = this.createElement('div', 'calculator__input-container');
        container.appendChild(input);
        return container;
    }
}

let IcmDefaults, calc;

if (document.getElementById('form-icm')) {
    IcmDefaults = {
        users: 20,
        defaultValue: 4,
        wrapperTriggers: 'icmWrapperTriggers',
        wrapperItems: 'icmWrapperItems',
    }

    calc = new IcmCalc(IcmDefaults);
}
